import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ExternalLink, Save } from "lucide-react";
import api from "../../lib/api";
import { AdminHeader, Btn } from "../../components/admin/Fields";
import { RealEstateCard, YenisehirCard } from "./SettingsPage";

/**
 * Dedicated screen to manage the two landing pages of the site
 * (/yenisehir + /realestate). Their data still lives inside site_settings
 * on the backend — we just moved the UI here to declutter Site Ayarları.
 */
const LandingPagesPage = () => {
  const [s, setS] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState("yenisehir");

  useEffect(() => {
    api.get("/admin/settings").then((r) => setS(r.data || {})).finally(() => setLoading(false));
  }, []);

  const set = (k, v) => setS((prev) => ({ ...prev, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", s);
      toast.success("Landing sayfaları kaydedildi");
    } catch (err) {
      toast.error(err?.response?.data?.detail || err.message);
    } finally {
      setSaving(false);
    }
  };

  const TABS = [
    { key: "yenisehir", label: "İstanbul Yenişehir", url: "/yenisehir" },
    { key: "realestate", label: "Fırat Real Estate", url: "/realestate" },
  ];

  return (
    <div data-testid="admin-landing-pages">
      <AdminHeader
        eyebrow="Landing"
        title="Landing Page Sayfaları"
        action={<Btn onClick={save} testId="save-landing" disabled={saving || loading}><Save size={14} strokeWidth={1.5} /> {saving ? "Kaydediliyor…" : "Kaydet"}</Btn>}
      />
      <p className="text-sm text-brand-medium mb-6 max-w-3xl">
        Kampanya odaklı iki landing sayfası bu ekrandan yönetilir. Her sekme kendi başlıkları, hero medyası,
        A/B varyantları, kartlar, SSS ve iletişim bilgilerini içerir.
      </p>

      {/* Tab bar */}
      <div className="flex flex-wrap items-center gap-1 mb-8 border-b border-brand-navy/10">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            className={`relative px-5 py-3 text-[0.66rem] tracking-[0.26em] uppercase font-medium transition-colors ${tab === t.key ? "text-brand-navy" : "text-brand-medium hover:text-brand-navy"}`}
            data-testid={`landing-tab-${t.key}`}
          >
            {t.label}
            {tab === t.key ? <span className="absolute left-0 right-0 -bottom-px h-0.5 bg-brand-primary" /> : null}
          </button>
        ))}
        <div className="ml-auto flex items-center gap-2 pr-1">
          <a
            href={TABS.find((t) => t.key === tab)?.url}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 text-xs text-brand-primary hover:text-brand-navy"
            data-testid="preview-landing"
          >
            <ExternalLink size={12} /> Sayfayı Aç
          </a>
        </div>
      </div>

      {loading ? (
        <div className="text-brand-medium text-sm py-10 text-center">Yükleniyor…</div>
      ) : tab === "yenisehir" ? (
        <YenisehirCard s={s} set={set} />
      ) : (
        <RealEstateCard s={s} set={set} />
      )}

      {/* Sticky save bar */}
      {!loading ? (
        <div className="sticky bottom-4 mt-8 flex justify-end">
          <div className="bg-white border border-brand-navy/10 shadow-lg px-5 py-3 flex items-center gap-3">
            <span className="text-xs text-brand-medium">Değişikliklerinizi kaydetmeyi unutmayın</span>
            <Btn onClick={save} testId="save-landing-2" disabled={saving}><Save size={14} strokeWidth={1.5} /> {saving ? "Kaydediliyor…" : "Kaydet"}</Btn>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default LandingPagesPage;
